module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-right": "5px"
    },
    attrs: {
      "xs6": "",
      "sm6": "",
      "mt-2": ""
    }
  }, [_c('p', {
    staticClass: "page_head center",
    style: ({
      color: _vm.styles.general.theme_color_light
    })
  }, [_c('b', [_vm._v("Page Views by Location")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "350px",
      "border": "0",
      "width": "100%"
    },
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "xs6": "",
      "sm6": "",
      "mt-2": ""
    }
  }, [_c('p', {
    staticClass: "page_head center",
    style: ({
      color: _vm.styles.general.theme_color_light
    })
  }, [_c('b', [_vm._v("Page Views by Page")])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.toppages), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "tab1"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', [_c('Progressd', {
      staticClass: "mb-2",
      attrs: {
        "value": item[2]
      }
    }), _vm._v(" "), _c('span', [_vm._v("   " + _vm._s(item[1]))])], 1)])
  }), 0)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b05991ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Index/block.vue
// module id = 1237
// module chunks = 0 1